// extracted by mini-css-extract-plugin
export default {"tags":"tags-module__tags___v3qhM","tags_body__action":"tags-module__tags_body__action___RnUy1"};